import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../UserContext';
import StudentNav from '../Navbars/StudentNav';
import Footer from '../Footer';
import { toast } from 'react-toastify';
import './StudentReward.css';
import axiosInstance from "./axiosInstance";
import axios from 'axios';

function StduentReward() {
  const [activeTab, setActiveTab] = useState('redeem');
  const [loading, setLoading] = useState(false);
  const [rewards, setRewards] = useState([]);
  const [earnedPoints, setEarnedPoints] = useState(0)
  const [redeemHistory, setRedeemHistory] = useState([]);
  const [selectedTerms, setSelectedTerms] = useState(null);
    const [showTermsModal, setShowTermsModal] = useState(false);
  const navigate = useNavigate();
  const { isStudent, setUserRole, setUserInfo, userInfo } = useContext(UserContext);

  // Fetch rewards from backend
  const fetchRewards = () => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_LOCAL_SERVER_API}/getRewardsForStudents`, {
      credentials: 'include',
    })
      .then((response) => {
        setEarnedPoints(parseInt(response?.data?.rewards_earned))
        setRewards(response.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching redeem Data:", error);
        toast.error("Failed to load redeem Data", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoading(false);
      });
  };
  useEffect(() => {
    

    fetchRewards();
  }, []);

  // Fetch redeem history from backend
  useEffect(() => {
    const fetchRedeemHistory = () => {
      setLoading(true);
      // axiosInstance.get("/StudentRedeemHistory")
      axios.get(`${process.env.REACT_APP_LOCAL_SERVER_API}/StudentRedeemHistory`, {
        credentials: 'include',
      })
        .then((response) => {
          // Format the data to match the frontend structure
          const formattedHistory = response.data.map(item => ({
            id: item.gift_id,
            gift: item.giftname,
            date: new Date(item.redeemtime).toLocaleDateString(),
            status: item.status,
            giftpicture: item.giftpicture, // Add gift picture to the history item
            student_name: item.student_name
          }));
          setRedeemHistory(formattedHistory);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching redeem history:", error);
          toast.error("Failed to load redeem history", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoading(false);
        });
    };

    if (activeTab === 'history') {
      fetchRedeemHistory();
    }else{
      fetchRewards();
    }
  }, [activeTab]);

  const handleRedeem = async (rewardId, points, earned) => {
    // alert(points + "__" + earned)
    if (points > earned) {
      toast.error("Need More Points To Redeem This Gift", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    setLoading(true);
    // alert(rewardId)
    const payload = {
      Gift_id: rewardId,
      User_id: userInfo?.User_id,
    };
    try {
      const response = await axios.post(`${process.env.REACT_APP_LOCAL_SERVER_API}/redeemGift`,
        payload, // Send JSON directly
        {
          headers: {
            'Content-Type': 'application/json', // Ensure JSON content type
          },
        }
      );

      if (response.data.success) {
        toast.success('Gift redeemed successfully!', {
          position: toast.POSITION.TOP_CENTER,
          className: 'kid-toast'
        });

        // Refresh the rewards list
        await axios.get(`${process.env.REACT_APP_LOCAL_SERVER_API}/getRewardsForStudents`, {
          credentials: 'include'
        }).then((res) => {
          const earned = res?.data?.rewards_earned
          setEarnedPoints(parseInt(earned))
          setRewards(res.data?.data);
        })

      }
    } catch (error) {
      console.error('Error redeeming gift:', error);
      toast.error('Failed to redeem gift. Please try again.', {
        position: toast.POSITION.TOP_CENTER,
        className: 'kid-toast'
      });
    } finally {
      setLoading(false);
    }
  };

  const onLogout = () => {
    fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/logout`, {
      credentials: "include",
      method: "POST",
    })
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
    setUserInfo(null);
    setUserRole("guest");
  };

  const username = userInfo?.username;

  return (
    <>
      {<StudentNav username={username} onLogout={onLogout} />}

      <div className="kid-redeem-container">
        <h1 className="page-title">🎉 Fun Rewards Shop 🎉</h1>
        <h6 className="page-title" style={{fontSize:"18px"}}>💰 My Points: {earnedPoints} 💰</h6>

        <div className="tabs-container">
          <button
            className={`tab-button ${activeTab === 'redeem' ? 'active' : ''}`}
            onClick={() => setActiveTab('redeem')}
          >
            🛍️ Redeem Gifts
          </button>
          <button
            className={`tab-button ${activeTab === 'history' ? 'active' : ''}`}
            onClick={() => setActiveTab('history')}
          >
            📜 Your Redeem History
          </button>
        </div>

        <div className="tab-content">
          {loading ? (
            <div className="loading-spinner">Loading rewards...</div>
          ) : activeTab === 'redeem' ? (
            <div className="gifts-grid">
              {rewards.map(reward => (
                <div key={reward.Gift_id} className="gift-card">
                  {reward.giftpicture ? (
                    <img
                      src={process.env.REACT_APP_LOCAL_SERVER_API+'/'+reward.giftpicture}
                      // alt={reward.giftname}
                      className="gift-image"
                    />
                  ) : (
                    <div className="gift-emoji">🎁</div>
                  )}
                  <h3>{reward.giftname}</h3>
                  <button 
                      className="terms-button"
                      onClick={() => {
                        setSelectedTerms(reward.TermsConditions);
                        setShowTermsModal(true);
                      }}
                    >
                      View Terms & Conditions
                    </button>
                  <p className="points">{reward.pointscost} points</p>
                  <button
                    className={parseInt(reward.pointscost) <= earnedPoints ? "redeem-button" : "redeem-button-disabled"}
                    onClick={() => handleRedeem(reward.Gift_id, parseInt(reward.pointscost), earnedPoints)}
                    disabled={loading}
                    title={parseInt(reward.pointscost) <= earnedPoints ? "Redeem":"Not Enough Points"}
                  >
                    {loading ? 'Redeeming...' : 'Redeem Now!'}
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <div className="history-list">
              {redeemHistory.length > 0 ? (
                redeemHistory.map(item => (
                  <div key={item.id} className="history-item">
                    {item.giftpicture ? (
                      <img
                        src={process.env.REACT_APP_LOCAL_SERVER_API+'/'+ item.giftpicture}
                        alt={item.gift}
                        className="history-item-image"
                      />
                    ) : (
                      <div className="history-item-emoji">🎁</div>
                    )}
                    <div className="item-details">
                      <h3>{item.gift}</h3>
                      <p>Date: {item.date}</p>
                      <p className={`status ${item.status.toLowerCase().replace(' ', '-')}`}>
                        Status: {item.status}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-history">
                  <p>No redeem history found</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
          {/* Terms & Conditions Modal */}
          {showTermsModal && (
          <div className="terms-modal-overlay">
            <div className="terms-modal">
              <h3>Terms & Conditions</h3>
              <div className="terms-content">
                {selectedTerms?.split('\n').map((line, i) => (
                  <p key={i} className="term-line">
                    {line.startsWith('-') ? '•' + line.substring(1) : line}
                  </p>
                ))}
              </div>
              <button 
                className="close-button"
                onClick={() => setShowTermsModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}

      <Footer />
    </>
  );
}

export default StduentReward;
